export default __webpack_public_path__ + "static/media/blasphemedflesh.6b2c4a9f.png";